<template>
  <div class="company-addresses">
    <div class="table-responsive table-full-width">
      <el-table class="table-striped"
                :data="addresses"
                border
                style="width: 100%"
                :max-height="tableHeight(400)">
        <el-table-column
          :render-header="addButton">
          <el-table-column
            prop="location"
            label="Location"
            min-width="80">
          </el-table-column>
          <el-table-column
            label="Street"
            min-width="80">
            <template slot-scope="props">
              {{ props.row.streetNumber }} {{ props.row.streetName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="city"
            label="City"
            min-width="80">
          </el-table-column>
          <el-table-column
            width="110"
            fixed="right"
            label="Actions">
            <template slot-scope="props">
              <p-button type="success" size="sm" icon>
                <i class="fa fa-edit" @click="handleEdit(props.row)"></i>
              </p-button>
              <p-button type="danger" v-if="canEdit" size="sm" icon @click="handleDelete(props.row)">
                <i class="fa fa-times"></i>
              </p-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import PButton from 'src/components/UIComponents/Button.vue'
  import {mapGetters} from 'vuex'
  import Permissions from 'src/utilities/permissions'
  import {getTableHeight} from 'src/utilities/utils'

  export default {
    components: {
      PButton
    },
    computed: {
      ...mapGetters({
        addresses: 'companies/companyAddresses'
      }),
      canEdit() {
        return this.$can('edit', Permissions.COMPANIES)
      }
    },
    methods: {
      addButton (h, e) {
        if (!this.canEdit) {
          return
        }
        const self = this
        const header = h('h5', {
          style: 'display:inline'
        })
        header.text = 'Addresses'
        const addButton = h('button', {
          props: {
            type: 'primary'
          },
          class: 'btn btn-fill btn-info pull-right el-icon-edit',
          style: 'padding: 8px',
          on: {
            click (e) {
              self.$eventHub.$emit('show-modal-5', 'Company Address', null, '600px')
            }
          }
        })

        return [header, addButton]
      },
      handleEdit (row) {
        this.$eventHub.$emit('show-modal-5', 'Company Address', row, '600px')
      },
      handleDelete (row) {
        this.$store.commit('companies/companyAddressRemove', row)
      },
      tableHeight(buffer) {
        return getTableHeight(buffer)
      }
    }
  }
</script>

<style scoped>
  .company-addresses {
    width: 100%
  }
</style>
